import { useEffect, useState, useCallback } from 'react'
import { residenceService } from 'services'
import { ISearchParams, ISearchResult } from 'interfaces'

function useSearch(searchParams?: ISearchParams, defaultResult?: ISearchResult, setError?: (error: any) => void) {
  const [results, setResults] = useState<ISearchResult>()

  const setSearchResult = useCallback(
    (results_: ISearchResult) => {
      setResults((r) => {
        return {
          hasMore: results_.hasMore,
          data: [...(searchParams?.offset === 0 || !r?.data ? [] : r.data), ...results_.data],
        }
      })
    },
    [searchParams?.offset],
  )
  const setSearchErrorResult = useCallback(
    (error: any) => {
      if (!!defaultResult) {
        setResults(defaultResult)
      }

      if (setError) {
        setError(error)
      }
    },
    [setError],
  )
  useEffect(() => {
    if (searchParams) {
      const controller = residenceService.search(searchParams || {}, setSearchResult, setSearchErrorResult)
      return () => controller.abort()
    }
  }, [searchParams, setSearchErrorResult, setSearchResult])

  return results
}

export default useSearch
